"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeForAppLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var GetPhoneDynamicCodeForAppLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetPhoneDynamicCodeForAppLogin, _super);
    function GetPhoneDynamicCodeForAppLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取快速登录手机验证码';
        _this.code = '101073';
        _this.desc = '获取快速登录手机验证码';
        _this.requestParams = new dynamicCode_1.GetPhoneDynamicCodeForAppLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetPhoneDynamicCodeForAppLogin;
}(service_1.BaseService));
exports.GetPhoneDynamicCodeForAppLogin = GetPhoneDynamicCodeForAppLogin;
//# sourceMappingURL=getPhoneDynamicCodeForAppLogin.js.map